import React from 'react'
import { Link } from 'gatsby'
import Layout from '../components/layout'
import MdBlock from '../components/mdBlock'

const PEPage = ({ data }) => {
	const content = data.allMarkdownRemark.edges[1].node.html;

	return (
	  <Layout>
	    <MdBlock content={ content } />
	    <div className="back-link">
			<Link to="/experience">&#10229;</Link>
	    </div>
	  </Layout>
	)
}

export default PEPage

export const pEPageQuery = graphql`
  query {
	  allMarkdownRemark(
	    sort: {fields: [frontmatter___name], order: ASC},
	  ) {
	    totalCount
	    edges {
	      node {
	        frontmatter {
	          name
	        }
	        html
	      }
	    }
	  }
	}
`